<template>
	<div>

		<!-- <el-button type="primary" @click="">添加</el-button> -->
		<el-card>
			<div>
				<!-- <el-input v-model="input" placeholder="请输入内容"></el-input> -->
				<el-date-picker unlink-panels=true @change="getDate" value-format="yyyy-MM-dd" v-model="date1" type="daterange"
					range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
				</el-date-picker>
			</div>
			<el-table :data="tableData" border style="width: 100%;"  height="750">
				<el-table-column type="index" label="序号" width="60">
				</el-table-column>
				<el-table-column prop="pushTime" label="发送时间" width="180">
				</el-table-column>
				<el-table-column prop="sender" label="发送人" width="180">
				</el-table-column>
				<el-table-column prop="receiver" label="接收人" width="180">
				</el-table-column>

				<el-table-column prop="templateName" label="模板名称">
				</el-table-column>
				<el-table-column prop="json" label="消息详情">
				</el-table-column>
				<el-table-column prop="type" label="类型" width="180">
				</el-table-column>
				<el-table-column prop="result" label="发送结果">
					<template slot-scope="scope">
						<span v-if="scope.row.result == 'ok'">成功</span>
						<span v-else>失败：原因-{{scope.row.result}}</span>
					</template>
				</el-table-column>
			</el-table>
		</el-card>
	</div>
</template>

<script>
	import cx from '../api/xxcx'
	import zt from '../api/zt'
	import getDates from '../json/getDate'
	export default {

		name: 'xxcx',
		data() {
			return {
				ztid: 0,
				tableData: [],
				ztlist: [],
				admin: '',
				date1: [getDates.currentMonthStart(), getDates.currentMonthEnd()],
				form: {
					ksrq: getDates.currentMonthStart(),
					jsrq: getDates.currentMonthEnd(),
					ztid: 1,
					zt: 'cs'
				}
			}
		},
		methods: {
			async getzt() {
				this.ztlist=[]
				let res = await zt.getAllzt()
				this.ztlist = res.data.data
			},
			async queryAllPushRecordInfo() {
				const {
					data: res
				} = await cx.queryAllPushRecordInfo(this.form)
				this.tableData = res.data
			},
			async queryPushRecordInfoByZtid() {
				const {
					data: res
				} = await cx.queryPushRecordInfoByZtid(this.form)
				this.tableData = res.data
			},
			getDate(e) {
				this.form.ksrq = e[0]
				this.form.jsrq = e[1]
				this.ifAdmin()
				console.log(e)
			},
			ifAdmin() {
				if (this.admin != "admin") {
					this.queryPushRecordInfoByZtid()
				} else {
					this.queryAllPushRecordInfo()
				}
			}
		},
		mounted() {
			this.ztid = sessionStorage.getItem('ztid')
			this.admin = sessionStorage.getItem("dm")
			this.ifAdmin()

		}
	}
</script>

<style>
</style>